export const getJSONPath = (obj, path) => {
  return path.split('.').reduce(function (o, k) {
    return o && o[k];
  }, obj);
};

export const setJSONPath = (obj, path, value) => {
  var i;
  path = path.split('.');
  for (i = 0; i < path.length - 1; i++) {
    obj = obj[path[i]];
  }
  obj[path[i]] = value;
};

export const getFormJSON = (e) => {
  let data = new FormData(e.target);
  var object = {};
  data.forEach(function (value, key) {
    if (key.indexOf('[') >= 0) {
      let keySplit = [];
      keySplit = key
        .replace(/\[/g, ']')
        .split(']')
        .filter(function (el) {
          return el != null && el !== '';
        });
      let path = [];
      keySplit.map((it, ix) => {
        path.push(it);
        let pathValue = isNaN(it) ? [] : {};
        pathValue = ix === keySplit.length - 1 ? value : pathValue;
        if (typeof getJSONPath(object, path.join('.')) === 'undefined') {
          setJSONPath(object, path.join('.'), pathValue);
        }
      });
    } else {
      object[key] = value;
    }
  });
  return object;
};
